import { pick, pipe, assoc } from 'ramda';

const getInitialValues = (location, shopName) => pipe(
  pick(['prefix', 'startingPONumber', 'billingAddressId']),
  assoc('name', shopName),
)(location);

export default getInitialValues;
